import { useResource } from '@landsbankinn/l16n';
import { Box, Flex, P } from '@landsbankinn/ui-kit';
import { MockAuthenticator } from 'src/components/Login/Form/MockAuthenticator.tsx';
import { type AudkenniAppHubData } from '../../../../services/ElectronicIdHubService';
import { Loading } from '../../../Loading';
import { useElectronicIdSubscriber } from '../../hooks/useElectronicIdSubscriber';
import { res } from './AudkenniAppCode.res';

export function AudkenniAppCode() {
  const { r } = useResource();
  const { data } = useElectronicIdSubscriber<AudkenniAppHubData>('AudkenniApp');
  const moreDescription = data?.holdingPageSigningMessage;
  const description = data?.code
    ? r(res.loadingAudkenniAppDescription(data.code))
    : '';
  return (
    <AudkenniAppLoading
      description={description}
      moreDescription={moreDescription}
      debugStateId={data?.debugStateId}
    />
  );
}

export function AudkenniAppLoadingWithCode({
  code,
  debugStateId,
}: {
  code: string;
  debugStateId?: string;
}) {
  const { r } = useResource();
  const description = code ? r(res.loadingAudkenniAppDescription(code)) : '';

  return (
    <Flex direction="col" mainAxisAlignment="center" height="100%">
      <AudkenniAppLoading
        description={description}
        debugStateId={debugStateId}
      />
    </Flex>
  );
}

function AudkenniAppLoading({
  description,
  moreDescription,
  debugStateId,
}: {
  description: string;
  moreDescription?: string;
  debugStateId?: string;
}) {
  const { r } = useResource();
  const title = r(res.loadingAudkenniAppTitle);
  return (
    <>
      <Loading
        title={title}
        description={
          <>
            <Box>
              <P fontVariant="body" paddingBottom="24">
                {description}
              </P>
              {moreDescription && <P fontVariant="body">{moreDescription}</P>}
            </Box>
          </>
        }
      />
      {debugStateId && (
        <MockAuthenticator debugUrl={'/ElectronicId/Mock?id=' + debugStateId} />
      )}
    </>
  );
}
